import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=5f9f8fbc&minapp=mpx&xlang=wxml&isComponent&outputPath=components%2Findex1da48bb6%2Findex"
import script from "./index.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Findex1da48bb6%2Findex"
export * from "./index.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Findex1da48bb6%2Findex"
import style0 from "./style.styl?vue&type=style&index=0&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22m1da48bb6%22%7D&isComponent&outputPath=components%2Findex1da48bb6%2Findex"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports